import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import {
    CommonPetitionerParams,
    ConfigurationPetitionerCreateRequest,
    ConfigurationPetitionerPatchInBatchRequest,
    ConfigurationPetitionerResponse
} from '@/modules/configurationModule/detail/automation/notifications/automation-notifications-case/services/configuration-petitioner/configuration-petitioner.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { CommonPetitionerResponse } from '@/api/services/common.dto'

class ConfigurationPetitionerService {
    async create(request: ConfigurationPetitionerCreateRequest): Promise<ConfigurationPetitionerResponse> {
        const response = await axios.post<ConfigurationPetitionerResponse>(`/configuration/petitioners`, request)
        return response.data
    }

    async paginator(filterModel?: CommonFilterModel, params?: CommonParams): Promise<IResponseAgGrid<ConfigurationPetitionerResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationPetitionerResponse>>(`/configuration/petitioners/`, { ...filterModel }, { params })
        return response.data
    }

    async get(petitionerId: number): Promise<ConfigurationPetitionerResponse> {
        const response = await axios.get<ConfigurationPetitionerResponse>(`/configuration/petitioners/${petitionerId}`)
        return response.data
    }

    async delete(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/petitioners/batch`, { data: request })
        return response.data
    }

    async patch(request: ConfigurationPetitionerPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/petitioners/batch`, request)
        return response.data
    }

    async search(params: CommonPetitionerParams): Promise<IResponseAgGrid<CommonPetitionerResponse>> {
        const response = await axios.get<IResponseAgGrid<CommonPetitionerResponse>>(`/configuration/petitioners/search`, { params })
        return response.data
    }
}

export const configurationPetitionerService = new ConfigurationPetitionerService()
